import { GetUsersRolesItem } from 'generatedTypes/user/models';

export const PILOT_ROLE: GetUsersRolesItem = GetUsersRolesItem.Pilot;

export const DEFAULT_PAGE_SIZE = 25;
